<div class="crop-overlay" *ngIf="visible && sourceFile" (click)="close()">
  <div class="crop-modal" (click)="$event.stopPropagation()">
    <button class="crop-close-btn" type="button" aria-label="Close" (click)="close()">&times;</button>
    <h3>{{ title }}</h3>
    <p class="crop-hint">{{ hint }}</p>

    <div class="crop-source-meta">
      <span class="crop-source-name">{{ sourceFile.name }}</span>
      <span class="crop-source-size">{{ formatFileSize(sourceFile.size) }}</span>
    </div>

    <div class="cropper-shell">
      <div
        #cropViewport
        class="cropper-viewport"
        [class.is-dragging]="isCropDragging"
        (pointerdown)="startCropDrag($event)"
        (pointermove)="onCropDrag($event)"
        (pointerup)="endCropDrag($event)"
        (pointercancel)="endCropDrag($event)"
        (wheel)="onCropWheel($event)"
      >
        <img
          *ngIf="cropSourceUrl"
          [src]="cropSourceUrl"
          [alt]="title"
          class="cropper-image"
          [style.transform]="cropImageTransform()"
          (load)="onCropImageLoad($event)"
          draggable="false"
        />
        <div class="cropper-mask" aria-hidden="true"></div>
      </div>
    </div>

    <div class="crop-controls">
      <label class="crop-zoom-control">
        <span>Zoom</span>
        <input type="range" min="1" max="4" step="0.05" [value]="cropZoom" (input)="onCropZoomChange($event)" />
      </label>
      <button type="button" class="crop-reset-btn" (click)="resetCropTransform()">Reset</button>
    </div>

    <p class="crop-note">{{ outputHint }}</p>
    <div class="crop-message error" *ngIf="cropError">{{ cropError }}</div>

    <div class="crop-actions">
      <button type="button" class="crop-action-btn secondary" (click)="close()">{{ cancelLabel }}</button>
      <button type="button" class="crop-action-btn primary" (click)="applyCropSelection()" [disabled]="isApplyingCrop">
        {{ isApplyingCrop ? 'Saving...' : confirmLabel }}
      </button>
    </div>
  </div>
</div>
